<app-ias-loader *ngIf="loading || loading1 || loading2"></app-ias-loader>
<app-accessibility-header></app-accessibility-header>
<app-state-header></app-state-header>
<div class="toast-container position-fixed top-0 end-0 p-3">
    <div id="liveToast" class="toast align-items-center text-bg-{{ toastType }} border-0" role="alert"
        aria-live="assertive" aria-atomic="true">
        <div class="d-flex">
            <div class="toast-body">
                {{ toastMessage }}
            </div>
            <button type="button" class="btn-close btn-close-white me-2 m-auto" data-bs-dismiss="toast"
                aria-label="Close"></button>
        </div>
    </div>
</div>
<main>
    <section class="hero-section position-relative text-white" [ngStyle]="{
    'background-image': 'url(' + pageData?.aboutBanner + ')',
   
  }">
        <div class="overlay"></div>

        <div class="container py-5">
            <div class="row align-items-center">
                <!-- Left: Text -->
                <div class="col-md-8 col-12 text-center text-md-start mb-4 mb-md-0">
                    <h6 class="fw-normal">Welcome to</h6>
                    <h2 class="fw-bold">Indian Administrative Service<br>Association</h2>
                    <p class="mb-0">{{pageData?.name}}</p>
                </div>

                <!-- Right: Logo -->
                <div class="col-md-4 text-center">
                    <img src="../../../../assets/images/microsite_logo.png" alt="IAS Logo" class="img-fluid">
                </div>
            </div>
        </div>
    </section>
    <section class="about-section">
        <div class="container">
            <div class="row align-items-center justify-content-center">



                <!-- Right: Content -->
                <div class="col-md-9 text-center">
                    <h3 class=" mb-4">
                        Indian Administrative Service Association {{pageData?.name}}
                    </h3>
                    <p class="mb-0">
                        The IAS Association {{pageData?.name}} embodies the spirit of the Indian Administrative Service.
                        It promotes excellence, camaraderie, and good governance through welfare initiatives and
                        community outreach, upholding the standards of public service and integrity.
                    </p>
                </div>

            </div>
        </div>
    </section>
    <section class="office-bearers-section">
        <div class="container">
            <h3 class="mb-5">Office Bearers</h3>

            <div id="officeBearersCarousel" class="carousel slide" data-bs-ride="carousel" data-bs-interval="6000"  *ngIf="groupedBearers && groupedBearers.length > 0; else noOffice">
                <div class="carousel-inner">

                    <!-- Each carousel-item contains up to 3 bearers -->
                    <div class="carousel-item" *ngFor="let group of groupedBearers; let i = index"
                        [class.active]="i === 0">
                        <div class="row ">
                            <div class="col-lg-3 col-6 mb-4 mb-lg-0" *ngFor="let bearer of group">
                                <div class="bearer-card text-center mx-auto">
                                    <div class="bearer-img mb-3">
                                        <img [src]="bearer?.bearerProfilePic" [alt]="bearer?.bearerName"
                                            class="img-fluid rounded-circle shadow">
                                    </div>
                                    <h5 class="bearer-name">{{ bearer?.bearerName }}</h5>
                                    <p class="bearer-role mb-3">{{ bearer?.bearerDesignation }}</p>
                                    <div class="social-icons d-flex justify-content-center gap-3">
                                        <a *ngIf="bearer?.facebookUrl" [href]="bearer?.facebookUrl" target="_blank"><svg
                                                xmlns="http://www.w3.org/2000/svg" width="29" height="29"
                                                viewBox="0 0 29 29" fill="none">
                                                <path fill-rule="evenodd" clip-rule="evenodd"
                                                    d="M12.3053 14.5261V19.361C12.3053 19.4313 12.3645 19.4863 12.4401 19.4863H14.371C14.4467 19.4863 14.5059 19.4313 14.5059 19.361V14.4466H15.9072C15.9763 14.4466 16.0355 14.3977 16.0421 14.3305L16.177 12.8512C16.1836 12.7779 16.1211 12.7137 16.0421 12.7137H14.5059V11.6624C14.5059 11.4148 14.7197 11.2162 14.9862 11.2162H16.0651C16.1408 11.2162 16.2 11.1611 16.2 11.0909V9.61163C16.2 9.54134 16.1408 9.48633 16.0651 9.48633H14.2395C13.1704 9.48633 12.302 10.2932 12.302 11.2865V12.7137H11.3349C11.2592 12.7137 11.2 12.7687 11.2 12.839V14.3182C11.2 14.3885 11.2592 14.4435 11.3349 14.4435H12.302V14.523L12.3053 14.5261Z"
                                                    fill="#523AB1" />
                                                <rect x="0.699997" y="0.986328" width="27" height="27" rx="13.5"
                                                    stroke="#523AB1" />
                                            </svg></a>
                                        <a *ngIf="bearer?.twitterUrl" [href]="bearer?.twitterUrl" target="_blank"><svg
                                                xmlns="http://www.w3.org/2000/svg" width="29" height="29"
                                                viewBox="0 0 29 29" fill="none">
                                                <g clip-path="url(#clip0_52831_3220)">
                                                    <path
                                                        d="M14.2 0.986328C21.6556 0.986328 27.7 7.03075 27.7 14.4863C27.7 21.9419 21.6556 27.9863 14.2 27.9863C6.74444 27.9863 0.700012 21.9419 0.700012 14.4863C0.700012 7.03075 6.74444 0.986328 14.2 0.986328Z"
                                                        stroke="#523AB1" />
                                                    <path
                                                        d="M15.1514 13.7206L18.8741 9.48633H17.9919L14.7595 13.1629L12.1777 9.48633H9.20001L13.1041 15.046L9.20001 19.4863H10.0822L13.4958 15.6037L16.2223 19.4863H19.2L15.1514 13.7206ZM10.4001 10.1362H11.7551L17.9923 18.866H16.6373L10.4001 10.1362Z"
                                                        fill="#523AB1" />
                                                </g>
                                                <defs>
                                                    <clipPath id="clip0_52831_3220">
                                                        <rect width="28" height="28" fill="white"
                                                            transform="translate(0.200012 0.486328)" />
                                                    </clipPath>
                                                </defs>
                                            </svg></a>
                                        <a *ngIf="bearer?.instagramUrl" [href]="bearer?.instagramUrl"
                                            target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="29"
                                                height="29" viewBox="0 0 29 29" fill="none">
                                                <path
                                                    d="M16.8298 11.3261C16.506 11.3261 16.2408 11.5885 16.2408 11.9151C16.2408 12.2418 16.5032 12.5042 16.8298 12.5042C17.1565 12.5042 17.4189 12.2418 17.4189 11.9151C17.4189 11.5885 17.1565 11.3261 16.8298 11.3261ZM14.2168 12.0798C12.8544 12.0798 11.7461 13.1882 11.7461 14.5505C11.7461 15.9129 12.8544 17.0212 14.2168 17.0212C15.5791 17.0212 16.6874 15.9129 16.6874 14.5505C16.6874 13.1882 15.5791 12.0798 14.2168 12.0798ZM14.2168 16.1335C13.3429 16.1335 12.6339 15.4244 12.6339 14.5505C12.6339 13.6767 13.3429 12.9676 14.2168 12.9676C15.0906 12.9676 15.7997 13.6767 15.7997 14.5505C15.7997 15.4244 15.0906 16.1335 14.2168 16.1335ZM19.2 12.4986C19.2 10.8347 17.8516 9.48633 16.1877 9.48633H12.2123C10.5484 9.48633 9.20001 10.8347 9.20001 12.4986V16.4741C9.20001 18.1379 10.5484 19.4863 12.2123 19.4863H16.1877C17.8516 19.4863 19.2 18.1379 19.2 16.4741V12.4986ZM18.2564 16.4741C18.2564 17.6159 17.3295 18.5427 16.1877 18.5427H12.2123C11.0705 18.5427 10.1436 17.6159 10.1436 16.4741V12.4986C10.1436 11.3568 11.0705 10.4299 12.2123 10.4299H16.1877C17.3295 10.4299 18.2564 11.3568 18.2564 12.4986V16.4741Z"
                                                    fill="#523AB1" />
                                                <rect x="0.700012" y="0.986328" width="27" height="27" rx="13.5"
                                                    stroke="#523AB1" />
                                            </svg></a>
                                        <a *ngIf="bearer?.linkedInUrl" [href]="bearer?.linkedInUrl"
                                            target="_blank"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28" fill="none">
  <path d="M19 15.0775V18.8303C19 18.9225 18.9295 19 18.8379 19H16.988C16.8999 19 16.8259 18.9262 16.8259 18.8303V15.3395C16.8259 14.4207 16.5123 13.7934 15.7266 13.7934C15.1276 13.7934 14.7717 14.214 14.6131 14.6236C14.5567 14.7712 14.5426 14.9742 14.5426 15.1771V18.8303C14.5426 18.9225 14.4722 19 14.3806 19H12.5307C12.4426 19 12.3686 18.9262 12.3686 18.8303C12.3721 17.9004 12.3897 13.3911 12.3721 12.3284C12.3721 12.2362 12.4426 12.1587 12.5307 12.1587H14.377C14.4651 12.1587 14.5391 12.2325 14.5391 12.3284V13.1292C14.5391 13.1292 14.5285 13.1439 14.525 13.1513H14.5391V13.1292C14.828 12.6642 15.3425 12 16.4947 12C17.9218 12 18.993 12.9779 18.993 15.0775H19ZM9.16209 19H11.012C11.1001 19 11.1741 18.9262 11.1741 18.8303V12.3284C11.1741 12.2362 11.1036 12.1587 11.012 12.1587H9.16209C9.074 12.1587 9 12.2325 9 12.3284V18.8303C9 18.9225 9.07048 19 9.16209 19Z" fill="#523AB1"/>
  <path d="M10 11C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11Z" fill="#523AB1"/>
  <rect x="0.5" y="0.5" width="27" height="27" rx="13.5" stroke="#523AB1"/>
</svg></a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- End Carousel Item -->

                </div>

                <!-- Controls -->
                <button class="carousel-control-prev" type="button" data-bs-target="#officeBearersCarousel"
                    data-bs-slide="prev">
                    <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Previous</span>
                </button>
                <button class="carousel-control-next" type="button" data-bs-target="#officeBearersCarousel"
                    data-bs-slide="next">
                    <span class="carousel-control-next-icon" aria-hidden="true"></span>
                    <span class="visually-hidden">Next</span>
                </button>
            </div>
             <ng-template #noOffice>
            <div class="text-center p-4 d-flex align-items-center justify-content-center nouser flex-column">
                <img src="../../../../assets/icons/empty-img-gray.png" alt="empty state">
                <p>Upcoming Office Bearers will be published here.</p>
            </div>
        </ng-template>
        </div>
    </section>
    <section class="news-events-section py-5">
        <div class="container py-4">

            <!-- Section Title -->
            <h3 class=" mb-4">Latest Events</h3>

            <!-- Tabs -->
            <!-- <div class="mb-4">
                <button class="btn tabbtn me-3" [ngClass]="{ 'tabactive': activeTab === 'news' }"
                    (click)="setTab('news')">
                    News
                </button>
                <button class="btn tabbtn" [ngClass]="{  'tabactive': activeTab === 'event' }"
                    (click)="setTab('event')">
                    Events
                </button>
            </div> -->

            <!-- Cards -->
            <div class="cardsrow" *ngIf="filteredItems && filteredItems.length > 0; else noEvent">
                <div class="news-card" *ngFor="let item of filteredItems">
                    <div class=" d-flex align-items-center justify-content-between gap-3 mb-3">
                        <p class="Published mb-0">
                            Published on: {{ item?.eventDate | date:'dd MMMM yyyy' }}
                        </p>
                        <img *ngIf="item.hasPdf" src="../../../../assets/images/pdf.png" alt="PDF"
                            class="pdf-icon ms-2">

                    </div>
                    <h6 class="fw-semibold text-primary mb-3">
                        {{ item?.title }}
                    </h6>

                    <p class="text-muted small mb-0">{{ item?.description }}</p>
                </div>
            </div>
             <ng-template #noEvent>
            <div class="text-center p-4 d-flex align-items-center justify-content-center nouser flex-column">
                <img src="../../../../assets/icons/empty-img-gray.png" alt="empty state">
                <p>Upcoming events will be published here.</p>
            </div>
        </ng-template>

        </div>
    </section>

    <div class="gallery-section py-5">
        <div class="container">
            <h3 class="section-title mb-4 ps-3">Gallery</h3>
            <div *ngIf="galleryImages && galleryImages.length > 0; else noUsers">
                <ngx-slick-carousel class="gallery-slider" #slickModal="slick-carousel" [config]="galleryslider">
                    <div ngxSlickItem *ngFor="let item of galleryImages" class="px-3">
                        <div class="gallery-card">
                            <img [src]="item.image" class="gallery-img " />
                        </div>
                    </div>

                </ngx-slick-carousel>
            </div>
            <ng-template #noUsers>
            <div class="text-center p-4 d-flex align-items-center justify-content-center nouser flex-column">
                <img src="../../../../assets/icons/empty-img-gray.png" alt="empty state">
                <p>Upcoming images will be published here.</p>
            </div>
        </ng-template>
        </div>
    </div>




</main>
<app-state-footer></app-state-footer>